var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcNotificationSentBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu alarm-element/NotificationSent-badge"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 479 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3943 3.27235C14.9801 3.85813 14.9801 4.80788 14.3943 5.39367L7.06099 12.727C6.4752 13.3128 5.52545 13.3128 4.93967 12.727L1.60633 9.39367C1.02055 8.80788 1.02055 7.85813 1.60633 7.27235C2.19212 6.68656 3.14187 6.68656 3.72765 7.27235L6.00033 9.54502L12.273 3.27235C12.8588 2.68656 13.8085 2.68656 14.3943 3.27235Z",
    fill: "#F86424"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotificationSentBadge);
export default __webpack_public_path__ + "static/media/ic-notification-sent-badge.733260bf2ebf2a0493f9ca43c76ea1f5.svg";
export { ForwardRef as ReactComponent };